import { create } from 'zustand';

type State = {
	patientType: string;
};

type Actions = {
	setPatientType: (patientType: string) => void;
};

export const usePatientTypeStore = create<State & Actions>((set) => ({
	patientType: '',
	setPatientType: (patientType) => set({ patientType }),
}));
